/**
 * This function is copied from https://github.com/emberjs/ember.js/blob/85a4f298f67ff70395cf7f9103682335162e0606/packages/%40ember/-internals/glimmer/lib/helpers/unique-id.ts#L49
 * Because it's only exported starting from Ember 5.2.0 and at the time of writing we still support Ember 4, once we drop support for Ember 4 we can remove this function and use the one from Ember.
 */
export function uniqueId(): string {
  // @ts-expect-error this one-liner abuses weird JavaScript semantics that
  // TypeScript (legitimately) doesn't like, but they're nonetheless valid and
  // specced.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/restrict-plus-operands
  return ([3e7] + -1e3 + -4e3 + -2e3 + -1e11).replace(/[0-3]/g, (a) =>
    ((a * 4) ^ ((Math.random() * 16) >> (a & 2))).toString(16),
  );
}

export const UNIQUE_ID = '{{UNIQUE_ID}}';
